module.exports = __webpack_public_path__ + "img/transparent_html.61513910.png";